import { apiService } from './apiService';

const customerAddressService = {
  async getAddresses() {
    try {
      const response = await apiService.get('/api/v1/customers/profile');
      return { success: true, data: response.addresses || [] };
    } catch (error) {
      console.error('Get addresses error:', error);
      return { success: false, message: error.message, data: [] };
    }
  },

  async createAddress(payload) {
    try {
      const response = await apiService.post('/api/v1/customers/addresses', payload);
      return { success: true, data: response };
    } catch (error) {
      console.error('Create address error:', error);
      return { success: false, message: error.message };
    }
  },

  async updateAddress(id, payload) {
    try {
      const response = await apiService.put(`/api/v1/customers/addresses/${id}`, payload);
      return { success: true, data: response };
    } catch (error) {
      console.error('Update address error:', error);
      return { success: false, message: error.message };
    }
  },

  async deleteAddress(id) {
    try {
      await apiService.delete(`/api/v1/customers/addresses/${id}`);
      return { success: true };
    } catch (error) {
      console.error('Delete address error:', error);
      return { success: false, message: error.message };
    }
  },
};

export default customerAddressService;
